import { noAuto } from "@fortawesome/fontawesome-svg-core";
import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  Image,
  View,
  Svg,
  Path
} from "@react-pdf/renderer";
import * as React from "react";
import moment from "moment";

import { IPdflink } from "../../types/interfaces";
import { getEncModeRegl, getEncStatut, verifyEncDate } from "../../services/misc";
import { constants } from "../../types/constants";

Font.register({
  family: 'Open Sans',
  fonts: [
  { src: '/fonts/open-sans-regular.ttf' },
  { src: '/fonts/open-sans-italic.ttf', fontStyle: "italic" },
  { src: '/fonts/open-sans-600italic.ttf', fontWeight: 600, fontStyle: "italic" },
  { src: '/fonts/open-sans-600.ttf', fontWeight: 600 },
  { src: '/fonts/open-sans-300.ttf', fontWeight: 300 }
  ]
});

Font.register({
  family: 'Cairo',
  fonts: [
    { src: '/fonts/Cairo-Regular.ttf' }, // Regular font
    { src: '/fonts/Cairo-Bold.ttf', fontWeight: 700 }, // Bold font
    { src: '/fonts/Cairo-Light.ttf', fontWeight: 300 } // Light font
  ]
});

const MyDocument: any = Document
const MyPage: any = Page
const MySvg: any = Svg

const VenteDocument: React.FC<IPdflink> = ({ documentType, data, showPreviewWatermark, title, fileObject }: IPdflink) => {
  if(!data)
    return (<MyDocument>
      <MyPage size="A4">
        <View>
          <Text>Erreur 968</Text>
        </View>
      </MyPage>
    </MyDocument>)
  
  const clientsColumns = [{value: "Nom", width: 20}, {value: "Prénom", width: 20}, {value: "CIN/Pass.", width: 20}, {value: "Tél.", width: 20}, {value: "Tél. 2", width: 20}],
    associationsColumns: any[] = [{value: "Étage", width: 8}, {value: "%", width: 8}, {value: "Pos.", width: 8}, {value: "m²", width: 8}, {value: "Date", width: 13}, {value: "Clients", width: 16}, {value: "Prix de vente", width: 13, formatNumber: true}, {value: "Avance", width: 13, formatNumber: true}, {value: "Reliquat", width: 13, formatNumber: true}],
    // encaissementsColumns: any[] = [{value: "Effectué par", width: 12}, {value: "Profit de", width: 12}, {value: "Montant", width: 11, formatNumber: true}, {value: "QP", width: 11, formatNumber: true}, {value: "Réf", width: 13.5}, {value: "Date", width: 11.5}, {value: "Banque", width: 9}, {value: "Type", width: 10}, {value: "Statut", width: 10}],
    // encaissementsColumns: any[] = [{value: "ID", width: 9}, {value: "Effectué par", width: 11}, {value: "Profit de", width: 11}, {value: "Montant", width: 10, formatNumber: true}, {value: "QP", width: 10, formatNumber: true}, {value: "Réf", width: 12.5}, {value: "Date", width: 10.5}, {value: "Banque", width: 8}, {value: "Type", width: 9}, {value: "Statut", width: 9}],
    encaissementsColumns: any[] = [{value: "ID", width: 5}, {value: "Effectué par", width: 11}, {value: "Profit de", width: 11}, {value: "Montant", width: 11, formatNumber: true}, {value: "QP", width: 11, formatNumber: true}, {value: "Réf", width: 13.5}, {value: "Date", width: 10}, {value: "Banque", width: 8}, {value: "Type", width: 9}, {value: "Statut", width: 10}],
    sortisColumns: any[] = [{value: "Réf", width: 15}, {value: "Montant", width: 12, formatNumber: true}, {value: "QP", width: 12, formatNumber: true}, {value: "Statut", width: 11}, {value: "Détails", width: 50}];

    let blockSaisie = false
    let blockSaisieMsg

    if(data.TYPE_VENTE !== "ASSOCIATION"){
      ({block: blockSaisie, blockMsg: blockSaisieMsg} = verifyEncDate(data.encaissements || data.contrat_encaissements, Number(data.PRIX_NET || 0), data.DATE_RESERV, data?.bien?.minEnc, data?.bien?.minEncIsNumber, data.ignoreNonEncaisse, data.forceBlockSaisie))
    }

    let aa = 1098000;
  const PAGE_SIDE_PADDING = 40,
    BORDER_COLOR = '#bfbfbf',
    BORDER_STYLE = 'solid';

    let aaa=[100, 100, 50, 100]

  const statutOrder = {
    [constants.STATUT_ENC_IMPAYE]: 0,
    [constants.STATUT_ENC_A_NE_PAS_VERSER_NR]: 1,
    [constants.STATUT_ENC_DEFAULT]: 2,
    [constants.STATUT_ENC_A_NE_PAS_VERSER_R]: 3,
    [constants.STATUT_ENC_PTF]: 4,
    [constants.STATUT_ENC_EI]: 5,
    [constants.STATUT_ENC_ENCAISSE]: 6,
    [constants.STATUT_ENC_REPRESENTE]: 7,
    [constants.STATUT_ENC_NOTAIRE]: 8
  }
  
  const sortis = (data.encaissements || data.contrat_encaissements || []).reduce((e, t) => [...e, ...(t.cheques_sortis ? t.cheques_sortis.map(e => ({...e, encaissement: t, CE_PART: t.PART})) : t.encaissement?.cheques_sortis ? t.encaissement.cheques_sortis.map(e => ({...e, encaissement: t.encaissement, CE_PART: t.PART})) : [])], []);
  
  const styles = StyleSheet.create({
    body: {
      padding: PAGE_SIDE_PADDING
    },
    logoContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12,
      marginBottom: 15
    },
    middleLogoContainer1: {
      flex: 5,
      display: "flex",
      flexDirection: "row"
    },
    middleLogoContainer2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "80%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: "green",
      color: "green",
      fontFamily: 'Open Sans'
    },
    middleLogoText: {
      width: "100%",
      // flex: 1,
      textAlign: "center",
      fontSize: 22,
      fontWeight: 600,
      textTransform: "uppercase"
    },
    middleLogoTextTop: {
      alignItems: "flex-end"
    },
    middleLogoTextBottom: {
      alignItems: "flex-start"
    },
    table: { 
      // display: "table", 
      width: "auto", 
      fontFamily: 'Open Sans',
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderRightWidth: 0, 
      borderBottomWidth: 0,
      marginBottom: 15
    },
    tableRow: { 
      margin: "auto", 
      flexDirection: "row" 
    },
    // footerRow: { 
    //   marginLeft: COL1_WIDTH + '%', 
    //   flexDirection: "row" 
    // },
    headerCol: { 
      backgroundColor: "#62af42e6",
      color: "white",
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderBottomColor: 'green',
      borderWidth: 1,
      fontWeight: 600,
      textAlign: "center"
    },
    rowCol: { 
      borderStyle: BORDER_STYLE, 
      borderColor: BORDER_COLOR,
      borderWidth: 1,
      textAlign: "center",
      fontFamily: 'Open Sans',
      fontWeight: 300,
      // borderLeftWidth: 0,
      // borderTopWidth: 0 
      justifyContent: "center", alignItems: "center", flexDirection: "row"
    },
    footerCol: {
      backgroundColor: "#62af42e6",
      color: "white",
      fontWeight: 600
    },
    cellText: { 
      marginVertical: 5,
      // marginHorizontal: 2,
      textAlign: "center",
      fontSize: 9
    },
    headerText: {
      fontWeight: 600
    },
    logo: {
      height: "auto",
      flex: 1
    },
    dateFournisseurView: {
      color: "#555555",
      fontSize: 12,
      // width: "100%",
      fontFamily: 'Open Sans',
      justifyContent: "flex-end",
      flexDirection: "row",
      marginBottom: 10
    },
    titlesView: {
      color: "#000000",
      fontSize: 12,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginTop: 7,
      marginBottom: 7
    },
    cardContainer1: {
      color: "#000000",
      fontSize: 10,
      fontFamily: 'Open Sans',
      width: "100%",
      justifyContent: "flex-start",
      flexDirection: "row",
      marginLeft: 2,
      marginBottom: 10
    },
    cardContainer2: {
      // display: "table",
      width: "100%"
    },
    cardRow: {
      width: "100%",
      flexDirection: "row",
      marginBottom: 4
    },
    cardCellTitle: {
      fontStyle: "italic",
      width: "20%"
    },
    cardCellValue: {
      fontWeight: 600,
      width: "20%"
    },
    cardCellSpace: {
      width: "20%"
    },
    arreteView: {
      color: "#333333",
      fontSize: 10,
      fontStyle: "italic",
      fontFamily: 'Open Sans',
      width: "100%",
      marginTop: 20
    },
    directionText: {
      color: "#000000",
      fontSize: 12,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      marginLeft: "70%",
      marginTop: 25
    },
    textMargin: {
      marginBottom: 4
    },
    watermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      transform: "rotate(-60deg)",
      fontSize: 50,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      // color: "#aaaaaa",
      color: "orangered",
      opacity: .2,
    },
    previewWatermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      fontSize: 80,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .4
    },
    borderTest: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "green"
    },
    borderTest2: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "red"
    },
    pageCountContainer: {
      position: "absolute",
      bottom: 4,//14
      left: PAGE_SIDE_PADDING,
      paddingTop: 8,
      paddingBottom: 8,
      width: "100%",
      color: "#333333",
      fontSize: 8
    },
    pageCountText: {
      textAlign: "center",
      marginBottom: 4
    },
    lastElement: {
      marginBottom: 0,
      paddingBottom: 0
    }
  });
  return (
  <MyDocument creator={"ayoub laazazi"} producer={"producer"} title={title} author={"ayoub laazazi"}>
    <MyPage size="A4" style={{...styles.body, position: "relative"}}>
      <View style={styles.watermark} fixed>
        <Text>{data.REMISE_VALIDEE === -1 && data.REMISE > 0 ? "REMISE NON VALIDÉE" : ""}</Text>
      </View>
      {showPreviewWatermark ? <View style={styles.previewWatermark} fixed>
        <Text>Aperçu</Text>
      </View> : null}
      {/* <View style={{
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        transform: "rotate(-90deg)",
        opacity: .1,
        overflow: "hidden"
      }} fixed>
        {[...Array(38)].map((_, rowIndex) => (
          <View key={rowIndex} style={{ flexDirection: 'row', justifyContent: 'center' }}>
            {[...Array(20)].map((_, colIndex) => (
              <Text key={colIndex} style={{
                  fontSize: 6,
                  fontFamily: 'Cairo',
                  color: "#aaaaaa",
                  marginHorizontal: 1,
                  marginVertical: 2,
                }}>شمس المدينة •</Text>
            ))}
          </View>
        ))}
      </View> */}
      <View fixed>
        <View style={styles.logoContainer}>
          <Image src={`/images/icon.png`} style={styles.logo}/>
          <View style={styles.middleLogoContainer1}>
            <View style={styles.middleLogoContainer2}>
              <Text style={{...styles.middleLogoText, ...styles.middleLogoTextTop}}>
                SHEMS AL MADINA
              </Text>
              <Text style={{...styles.middleLogoText, ...styles.middleLogoTextBottom}}>
                {data.PROJET ? data.PROJET.toUpperCase() : "---"}
              </Text>
            </View>
          </View>
          <Image src={`/images/icon.png`} style={styles.logo}/>
        </View>
      </View>
      
      {false ? <View style={{fontSize: 9, flexDirection: "row"}}>
        <View style={{flex: 1}}></View>
        <View style={{flex: 1}}></View>
        <View style={{flex: 1, ...styles.borderTest, borderColor: "black", flexDirection: "column"}}>
          <View style={{flex: 2, flexDirection: "row"}}>
            <Text style={{flex: 2}}></Text>
            {aaa.map(e => <Text style={{flex: 3}}>{e}</Text>)}
          </View>
          <View style={{flex: 5, flexDirection: "row"}}>
            <Text style={{flex: 1, alignItems: "center", justifyContent: "center"}}>%</Text>
            <View style={{flex: 1, flexDirection: "column", borderRightWidth: "1px", borderRightStyle: "solid", borderRightColor: "black"}}>
              <Text style={{flex: 1}}>100</Text>
              <Text style={{flex: 1}}>80</Text>
              <Text style={{flex: 1}}>60</Text>
              <Text style={{flex: 1}}>40</Text>
              <Text style={{flex: 1}}>20</Text>
              <Text style={{flex: 1}}>0</Text>
            </View>
            {aaa.map(e => <View style={{flex: 3, justifyContent: "center", alignItems: "flex-end"}}>
              <View style={{backgroundColor: "green", width: "90%", height: `${e}%`, justifyContent: "center", alignItems: "center"}}>
                <Text>{e}</Text>
              </View>
            </View>)}
          </View>
          <View style={{flex: 2, flexDirection: "row", borderTopWidth: "1px", borderTopStyle: "solid", borderTopColor: "black"}}>
            <Text style={{flex: 2}}></Text>
            <Text style={{flex: 3}}>RDC</Text>
            <Text style={{flex: 3}}>1 ER</Text>
            <Text style={{flex: 3}}>2 EME</Text>
            <Text style={{flex: 3}}>3 EME</Text>
          </View>
          <View style={{flex: 1}}>
            <Text style={{textAlign: "center"}}>ETAGE</Text>
          </View>
        </View>
      </View> : null}
      
      <View style={styles.titlesView}>
        <Text>
          Infos Clients : 
        </Text>
      </View>
      <View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            {clientsColumns.map((e, key) => 
              <View style={Object.assign({}, styles.headerCol, {width: e.width + "%"})} key={key}>
                <Text style={Object.assign({}, styles.cellText, styles.headerText)}>{ e.value }</Text>
              </View>
            )}
          </View>
          {((data.clients || data.contrat_clients?.map(e => e.client))?.filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || []).map((client, clientKey) => {
          // {data.clients?.map((client, clientKey) => {
            return <View style={styles.tableRow} key={clientKey}>
              {[{value: client.NOM || "-"}, {value: client.PRENOM || "-"}, {value: client.CIN || client.PASSPORT || "-"}, {value: client.TEL || "-"}, {value: client.TEL2 || "-"}].map((e, key) => 
                <View style={Object.assign({}, styles.rowCol, {width: clientsColumns[key].width + "%"})} key={key}>
                  {!!(key === 0 && client.CIVILITE === "Ste") && <MySvg viewBox="0 0 448 512" style={{width: 10, height: 10, marginRight: 5}}>
                    <Path d="M436 480h-20V24c0-13.3-10.7-24-24-24H56C42.7 0 32 10.7 32 24v456H12c-6.6 0-12 5.4-12 12v20h448v-20c0-6.6-5.4-12-12-12zM128 76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V76zm0 96c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm52 148h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm76 160h-64v-84c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84zm64-172c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z" fill="green" />
                  </MySvg>}
                  <Text style={Object.assign({}, styles.cellText)}>
                    {e.value}
                  </Text>
                </View>
              )}
            </View>
          })}
        </View>
      </View>
      
      {data.associations?.length > 0 ? <View style={styles.titlesView}>
        <Text>
          Association : 
        </Text>
      </View> : null}
      {data.associations?.length > 0 ? <View>
        <View style={styles.table}>
          <View style={styles.tableRow} wrap={false}>
            {associationsColumns.map((e, key) => 
              <View style={Object.assign({}, styles.headerCol, {width: e.width + "%"})} key={key}>
                <Text style={Object.assign({}, styles.cellText, styles.headerText)}>{ e.value }</Text>
              </View>
            )}
          </View>
          {data.associations.sort((a, b) => Number(a.ETAGE || 0) - Number(b.ETAGE || 0)).map((association, associationKey) => {
            return <View style={styles.tableRow} key={associationKey} wrap={false}>
              {[association.ETAGE === "0" ? "RDC" : (association.ETAGE || "-"), association.POURCENTAGE ? `${association.POURCENTAGE}%` : "-", association.POSITION || "-", association.SUPERFICIE ? `${association.SUPERFICIE}m²` : "-", association.createdAt ? moment(association.createdAt).format('DD/MM/YYYY') : "-", association.contrat_clients?.map(e => <View><Text>{`${e.client?.NOM || "-"} ${e.client?.PRENOM || ""}`}</Text></View>) || "-", Number(association.PRIX_VENTE) || 0, association.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0, (Number(association.PRIX_VENTE) || 0) - (association.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0)].map((e, key) => 
                <View style={Object.assign({}, styles.rowCol, {width: associationsColumns[key].width + "%"})} key={key}>
                  <Text style={Object.assign({}, styles.cellText)}>{ (e = e || 0, associationsColumns[key].formatNumber ? Number(e).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : associationsColumns[key].isDecimal ? Number((+e).toFixed(2)) : e) }</Text>
                </View>
              )}
            </View>
          })}
          <View style={styles.tableRow} wrap={false}>
            <View style={Object.assign({}, styles.rowCol, styles.footerCol, {width: associationsColumns[6].width + "%", marginLeft: associationsColumns.reduce((e, t, i) => {return i <= 5 ? e + (t.width || 0) : e}, 0) + "%"})}>
              <Text style={Object.assign({}, styles.cellText)}>{data.associations.reduce((prev, b) => prev + (Number(b.PRIX_VENTE) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"}</Text>
            </View>
            <View style={Object.assign({}, styles.rowCol, styles.footerCol, {width: associationsColumns[7].width + "%"})}>
              <Text style={Object.assign({}, styles.cellText)}>{data.associations.reduce((prev, b) => prev + (b.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"}</Text>
            </View>
            <View style={Object.assign({}, styles.rowCol, styles.footerCol, {width: associationsColumns[8].width + "%"})}>
              <Text style={Object.assign({}, styles.cellText)}>{(data.associations.reduce((prev, b) => prev + (Number(b.PRIX_VENTE) || 0), 0) - data.associations.reduce((prev, b) => prev + (b.contrat_encaissements?.reduce((e, t) => {return t.PART ? e + t.PART : e}, 0) || 0), 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"}</Text>
            </View>
          </View>
        </View>
      </View> : null}

      <View style={styles.titlesView}>
        <Text style={{flex: 1}}>
          Bien : 
        </Text>
        {!!(data.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE || data.en_cours_signature === 1 || data.chez_notaire === 1) && <View style={{display: "flex", flex: 1, flexDirection: "row", justifyContent: "flex-end", alignItems: "center"}}>
          <Text style={{color: "white", backgroundColor: data.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE ? "green" : data.en_cours_signature === 1 ? "cadetblue" : data.chez_notaire === 1 ? "brown" : "black", borderRadius: 10, paddingHorizontal: 6, paddingVertical: 1, fontSize: 10}}>
            {data.bien?.STATUT === constants.STATUT_SIGNE_NOTAIRE ? "Signé Notaire" : data.en_cours_signature === 1 ? "Signature En Cours" : data.chez_notaire === 1 ? "Signé Client" : "-"}
          </Text>
        </View>}
        {!!blockSaisie && <View style={{display: "flex", flex: 1, flexDirection: "row", justifyContent: "flex-end", alignItems: "center"}}>
          <Text style={{color: "white", backgroundColor: "red", borderRadius: 10, paddingHorizontal: 6, paddingVertical: 1, fontSize: 10}}>
            {`${data.TYPE_VENTE === "ASSOCIATION" ? "Part" : "Vente"} bloquée pour la saisie`}
          </Text>
        </View>}
      </View>
      <View style={styles.cardContainer1}>
        <View style={styles.cardContainer2}>
          <View style={styles.cardRow}>
            <Text style={styles.cardCellTitle}>Tranche:</Text>
            <Text style={styles.cardCellValue}>{data.TRANCHE || data.bien?.TRANCHE || "-"}</Text>
            <View style={styles.cardCellSpace}></View>
            {data.TYPE_VENTE !== "ASSOCIATION" ? <Text style={styles.cardCellTitle}>Étage:</Text> : null}
            {data.TYPE_VENTE !== "ASSOCIATION" ? <Text style={styles.cardCellValue}>{data.ETAGE !== undefined && data.ETAGE !== null ? data.ETAGE : data.bien ? data.bien.ETAGE : "-"}</Text> : null}
          </View>
          <View style={styles.cardRow}>
            <Text style={styles.cardCellTitle}>Type:</Text>
            <Text style={styles.cardCellValue}>{data.TYPE || data.bien?.TYPE || "-"}</Text>
            <View style={styles.cardCellSpace}></View>
            {/* <Text style={styles.cardCellTitle}>ID Bien:</Text>
            <Text style={styles.cardCellValue}>{data.bien?.id || "PAS ENCORE VENDU"}</Text> */}
            <Text style={styles.cardCellTitle}>Titre foncier:</Text>
            <Text style={styles.cardCellValue}>{data.bien?.TF || "-"}</Text>
          </View>
          <View style={styles.cardRow}>
            <Text style={styles.cardCellTitle}>Dossier:</Text>
            <Text style={styles.cardCellValue}>{data.NUM_DOSS}</Text>
            <View style={styles.cardCellSpace}></View>
            <Text style={styles.cardCellTitle}>Surface:</Text>
            <Text style={styles.cardCellValue}>{data.SUPERFICIE !== undefined && data.SUPERFICIE !== null ? (data.SUPERFICIE + "m²") : data.bien ? (data.bien.SUPERFICIE + "m²") : "-"}</Text>
          </View>
          <View style={styles.cardRow}>
            <Text style={styles.cardCellTitle}>Désignation:</Text>
            <Text style={styles.cardCellValue}>{data.DESIGNATION || data.bien?.DESIGNATION || "-"}</Text>
            <View style={styles.cardCellSpace}></View>
            <Text style={styles.cardCellTitle}>Chargé du bien:</Text>
            <Text style={styles.cardCellValue}>{data.chargeBienUser?.LOGIN || "-"}</Text>
          </View>
        </View>
      </View>

      <View style={styles.titlesView}>
        <Text>
          Détails Vente : 
        </Text>
      </View>
      <View style={styles.cardContainer1}>
        <View style={{/*display: "table", */width: "100%"}}>
          <View style={styles.cardRow}>
            <Text style={styles.cardCellTitle}>Commercial:</Text>
            <Text style={styles.cardCellValue}>{data.comUser?.LOGIN || data.SAISIE_PAR || "-"}</Text>
            <View style={styles.cardCellSpace}></View>
            <Text style={styles.cardCellTitle}>Prix du M²:</Text>
            <Text style={styles.cardCellValue}>{data.PRIX_M ? (Number(data.PRIX_M).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH") : "-"}</Text>
            {/* <Text style={styles.cardCellTitle}>Prix du Bien M²:</Text>
            <Text style={styles.cardCellValue}>{data.PRIX_M_BIEN ? (Number(data.PRIX_M_BIEN).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH") : data.bien && data.bien.PRIX_M ? (Number(data.bien.PRIX_M).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH") : "-"}</Text> */}
          </View>
          <View style={styles.cardRow}>
            {/* <Text style={styles.cardCellTitle}>Prix du Bien:</Text>
            <Text style={styles.cardCellValue}>{data.PRIX_BIEN !== undefined && data.PRIX_BIEN !== null ? (Number(data.PRIX_BIEN).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH") : data.bien && data.bien.PRIX_VENTE !== undefined && data.bien.PRIX_VENTE !== null ? (Number(data.bien.PRIX_VENTE).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH") : "-"}</Text> */}
            <Text style={styles.cardCellTitle}>Date Vente:</Text>
            <Text style={styles.cardCellValue}>{data.DATE_RESERV ? moment(data.DATE_RESERV).format('DD/MM/YYYY') : "-"}</Text>
            <View style={styles.cardCellSpace}></View>
            <Text style={{...styles.cardCellTitle, fontWeight: 600}}>Prix Net:</Text>
            <Text style={{...styles.cardCellValue, ...(data.REMISE_VALIDEE === -1 && data.REMISE > 0 ? {color: "orangered"} : data.REMISE_VALIDEE === 0 && data.REMISE > 0 ? {color: "red"} : {})}}>{(Number(data.PRIX_NET) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH" + ((data.REMISE_VALIDEE === 0 || data.REMISE_VALIDEE === -1) && data.REMISE > 0 ? " *" : "")}</Text>
            {/* <Text style={styles.cardCellTitle}>Prix comm. Client:</Text>
            <Text style={styles.cardCellValue}>{data.PRIX_M_CLIENT !== undefined && data.PRIX_M_CLIENT !== null ? (Number(data.PRIX_M_CLIENT).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH") : "-"}</Text> */}
          </View>
          <View style={styles.cardRow}>
            <Text style={styles.cardCellTitle}>ID Vente:</Text>
            <Text style={styles.cardCellValue}>{data.id || "PAS ENCORE VENDU"}</Text>
            <View style={styles.cardCellSpace}></View>
            <Text style={styles.cardCellTitle}>Total valeur(s) reçue(s):</Text>
            <Text style={styles.cardCellValue}>{(data.encaissements || data.contrat_encaissements || []).reduce((prev, b) => prev + (Number(b.PART) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH"}</Text>
            {/* <Text style={{...styles.cardCellValue, ...(data.REMISE_VALIDEE === -1 && data.REMISE > 0 ? {color: "orangered"} : data.REMISE_VALIDEE === 0 && data.REMISE > 0 ? {color: "red"} : {})}}>{((data.PRIX_M_CLIENT !== undefined && data.PRIX_M_CLIENT !== null) || (data.PRIX_NET !== undefined && data.PRIX_NET !== null) || (data.bien && data.bien.PRIX_VENTE !== undefined && data.bien.PRIX_VENTE !== null)) ? (((Number(data.PRIX_M_CLIENT) || Number(data.PRIX_NET) || (data.bien ? Number(data.bien.PRIX_VENTE) : 0) || 0) - (data.REMISE_VALIDEE === 0 ? 0 : (Number(data.REMISE) || 0))).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH" + ((data.REMISE_VALIDEE === 0 || data.REMISE_VALIDEE === -1) && data.REMISE > 0 ? " *" : "")) : "-"}</Text> */}
          </View>
          <View style={styles.cardRow}>
            <Text style={styles.cardCellTitle}>Remise:</Text>
            <Text style={{...styles.cardCellValue, ...(data.REMISE_VALIDEE === -1 && data.REMISE > 0 ? {color: "orangered"} : data.REMISE_VALIDEE === 0 && data.REMISE > 0 ? {color: "red"} : {})}}>{data.REMISE !== undefined && data.REMISE !== null ? ((Number(data.REMISE) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH" + ((data.REMISE_VALIDEE === 0 || data.REMISE_VALIDEE === -1) && data.REMISE > 0 ? " *" : "")) : "-"}</Text>
            <View style={styles.cardCellSpace}></View>
            <Text style={styles.cardCellTitle}>Reliquat:</Text>
            <Text style={{...styles.cardCellValue, ...(data.REMISE_VALIDEE === -1 && data.REMISE > 0 ? {color: "orangered"} : data.REMISE_VALIDEE === 0 && data.REMISE > 0 ? {color: "red"} : {})}}>{(data.encaissements || data.contrat_encaissements) ? (((Number(data.PRIX_NET) || 0) - (data.encaissements || data.contrat_encaissements).reduce((prev, b) => prev + (Number(b.PART) || 0), 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH" + ((data.REMISE_VALIDEE === 0 || data.REMISE_VALIDEE === -1) && data.REMISE > 0 ? " *" : "")) : "-"}</Text>
            {/* <Text style={{...styles.cardCellValue, ...(data.REMISE_VALIDEE === -1 && data.REMISE > 0 ? {color: "orangered"} : data.REMISE_VALIDEE === 0 && data.REMISE > 0 ? {color: "red"} : {})}}>{(data.encaissements || data.contrat_encaissements) && ((data.PRIX_M_CLIENT !== undefined && data.PRIX_M_CLIENT !== null) || (data.PRIX_NET !== undefined && data.PRIX_NET !== null) || (data.bien && data.bien.PRIX_VENTE !== undefined && data.bien.PRIX_VENTE !== null)) ? (((Number(data.PRIX_M_CLIENT) || Number(data.PRIX_NET) || (data.bien ? Number(data.bien.PRIX_VENTE) : 0) || 0) - (data.encaissements || data.contrat_encaissements).reduce((prev, b) => prev + (Number(b.PART) || 0), 0) - (data.REMISE_VALIDEE === 0 ? 0 : (Number(data.REMISE) || 0))).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " DH" + ((data.REMISE_VALIDEE === 0 || data.REMISE_VALIDEE === -1) && data.REMISE > 0 ? " *" : "")) : "-"}</Text> */}
          </View>
        </View>
      </View>

      <View style={styles.titlesView}>
        <Text>
          Détail valeur(s) reçue(s) : 
        </Text>
      </View>
      <View>
        <View style={{...styles.table, ...styles.lastElement}}>
          <View style={styles.tableRow} wrap={false}>
            {encaissementsColumns.map((e, key) => 
              <View style={Object.assign({}, styles.headerCol, {width: e.width + "%"})} key={key}>
                <Text style={Object.assign({}, styles.cellText, styles.headerText)}>{ e.value }</Text>
              </View>
            )}
          </View>
          {/* {data.encaissements ? data.encaissements.map((encaissement, encaissementKey) => {
            return <View style={styles.tableRow} key={encaissementKey} wrap={false}>
              {[encaissement.TIRE_PAR || "-", encaissement.contrat_encaissement ? (encaissement.contrat_encaissement.PROFIT_DE && encaissement.contrat_encaissement.PROFIT_DE != "00000000000000000" ? encaissement.contrat_encaissement.PROFIT_DE : "-") : (encaissement.PROFIT_DE && encaissement.PROFIT_DE != "00000000000000000" ? encaissement.PROFIT_DE : "-"), Number(encaissement.MONTANT) || 0, encaissement.contrat_encaissement ? (Number(encaissement.contrat_encaissement.PART) || 0) : (Number(encaissement.PART) || 0), encaissement.REF_REGLEMENT || "-", encaissement.DATE_REGLEMENT ? moment(encaissement.DATE_REGLEMENT).format('DD/MM/YYYY') : "-", encaissement.BANQUE || "-", encaissement.contrat_encaissement ? (encaissement.contrat_encaissement.TYPE_ECHEANCE || "-") : (encaissement.TYPE_ECHEANCE || "-")].map((e, key) => 
                <View style={Object.assign({}, styles.rowCol, {width: encaissementsColumns[key].width + "%"})} key={key}>
                  <Text style={Object.assign({}, styles.cellText)}>{ (e = e || 0, encaissementsColumns[key].formatNumber ? Number(e).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : encaissementsColumns[key].isDecimal ? Number((+e).toFixed(2)) : e) }</Text>
                </View>
              )}
            </View> */}
          {data.encaissements ? data.encaissements.sort((a, b)=> {
            if(statutOrder[a.STATUT] !== statutOrder[b.STATUT])
              return statutOrder[a.STATUT] - statutOrder[b.STATUT]

            if(!a.date_encaisse_impaye && !b.date_encaisse_impaye)
              return 0
            else if(!a.date_encaisse_impaye)
              return 1
            else if(!b.date_encaisse_impaye)
              return -1
            else
              return a.date_encaisse_impaye > b.date_encaisse_impaye ? -1 : a.date_encaisse_impaye < b.date_encaisse_impaye ? 1 : 0
          }).map((ee, eeKey) => {
            return <View style={styles.tableRow} key={eeKey} wrap={false}>
              {[ee.id || "-", ee.TIRE_PAR || "-", ee.PROFIT_DE ? ee.PROFIT_DE : "-", Number(ee.MONTANT) || 0, Number(ee.PART) || 0, ee.REF_REGLEMENT || "-", ee.DATE_REGLEMENT ? moment(ee.DATE_REGLEMENT).format('DD/MM/YYYY') : "-", ee.BANQUE || "-", getEncModeRegl(ee.MODE_REGL), `${getEncStatut(ee.STATUT, true)}${(ee.STATUT === constants.STATUT_ENC_ENCAISSE || ee.STATUT === constants.STATUT_ENC_REPRESENTE) && ee.date_encaisse_impaye ? ` (${moment(ee.date_encaisse_impaye).format('DD/MM/YYYY')})` : ""}${ee.notValid == 1 ? ` (non validé)` : ""}`/*, encaissement.STATUT === "RECEPTION" ? "Non Récep." : encaissement.STATUT === "PTF" ? "Réceptionné" : encaissement.STATUT === "EI" ? "Versé" : encaissement.STATUT === "ENCAISSE" ? "Encaissé" : encaissement.STATUT === "IMPAYE" ? "Impayé" : encaissement.STATUT === "RECUPERE" ? "Récupéré" : (encaissement.STATUT || "")*/].map((e, key) => 
                <View style={Object.assign({}, styles.rowCol, {width: encaissementsColumns[key].width + "%"}, ee.STATUT === "IMPAYE" ? {backgroundColor: constants.encImpColor} : ee.notValid == 1 ? {backgroundColor: constants.encNotValidColor} : ee.STATUT === constants.STATUT_ENC_DEFAULT ? {backgroundColor: constants.encNrColor} : ee.STATUT === constants.STATUT_ENC_PTF ? {backgroundColor: constants.encRColor} : {})} key={key}>
                  <Text style={Object.assign({}, styles.cellText, {fontSize: "7px"})}>{ (e = e || 0, encaissementsColumns[key].formatNumber ? Number(e).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : encaissementsColumns[key].isDecimal ? Number((+e).toFixed(2)) : e) }</Text>
                </View>
              )}
            </View>
          }) : data.contrat_encaissements?.sort((a, b)=> {
            if(statutOrder[a.encaissement?.STATUT] !== statutOrder[b.encaissement?.STATUT])
              return statutOrder[a.encaissement?.STATUT] - statutOrder[b.encaissement?.STATUT]
            
            if(!a.encaissement?.date_encaisse_impaye && !b.encaissement?.date_encaisse_impaye)
              return 0
            else if(!a.encaissement?.date_encaisse_impaye)
              return 1
            else if(!b.encaissement?.date_encaisse_impaye)
              return -1
            else
              return a.encaissement?.date_encaisse_impaye > b.encaissement?.date_encaisse_impaye ? -1 : a.encaissement?.date_encaisse_impaye < b.encaissement?.date_encaisse_impaye ? 1 : 0
          }).map((ee, eeKey) => {
            return <View style={styles.tableRow} key={eeKey} wrap={false}>
              {[ee.encaissementId || "-", ee.encaissement?.TIRE_PAR || "-", ee.PROFIT_DE ? ee.PROFIT_DE : "-", Number(ee.encaissement?.MONTANT || 0) || 0, Number(ee.PART) || 0, ee.encaissement?.REF_REGLEMENT || "-", ee.encaissement?.DATE_REGLEMENT ? moment(ee.encaissement?.DATE_REGLEMENT).format('DD/MM/YYYY') : "-", ee.encaissement?.BANQUE || "-", getEncModeRegl(ee.encaissement?.MODE_REGL), `${getEncStatut(ee.encaissement?.STATUT, true)}${(ee.encaissement?.STATUT === constants.STATUT_ENC_ENCAISSE || ee.encaissement?.STATUT === constants.STATUT_ENC_REPRESENTE) && ee.encaissement?.date_encaisse_impaye ? ` (${moment(ee.encaissement?.date_encaisse_impaye).format('DD/MM/YYYY')})` : ""}${ee.encaissement?.notValid == 1 ? ` (non validé)` : ""}`/*, contrat_encaissement.encaissement?.STATUT === "RECEPTION" ? "Non Récep." : contrat_encaissement.encaissement?.STATUT === "PTF" ? "Réceptionné" : contrat_encaissement.encaissement?.STATUT === "EI" ? "Versé" : contrat_encaissement.encaissement?.STATUT === "ENCAISSE" ? "Encaissé" : contrat_encaissement.encaissement?.STATUT === "IMPAYE" ? "Impayé" : (contrat_encaissement.encaissement?.STATUT || "")*/].map((e, key) => 
                <View style={Object.assign({}, styles.rowCol, {width: encaissementsColumns[key].width + "%"}, ee.encaissement?.STATUT === "IMPAYE" ? {backgroundColor: constants.encImpColor} : ee.encaissement?.notValid == 1 ? {backgroundColor: constants.encNotValidColor} : ee.encaissement?.STATUT === constants.STATUT_ENC_DEFAULT ? {backgroundColor: constants.encNrColor} : ee.encaissement?.STATUT === constants.STATUT_ENC_PTF ? {backgroundColor: constants.encRColor} : {})} key={key}>
                  <Text style={Object.assign({}, styles.cellText, {fontSize: "7px"})}>{ (e = e || 0, encaissementsColumns[key].formatNumber ? Number(e).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : encaissementsColumns[key].isDecimal ? Number((+e).toFixed(2)) : e) }</Text>
                </View>
              )}
            </View>
          })}
          <View style={Object.assign({}, styles.rowCol, styles.footerCol, {width: encaissementsColumns[4].width + "%", marginLeft: (encaissementsColumns[0].width + encaissementsColumns[1].width + encaissementsColumns[2].width + encaissementsColumns[3].width) + "%"})}>
            <Text style={Object.assign({}, styles.cellText, {fontSize: "7px"})}>{(data.encaissements || data.contrat_encaissements)?.reduce((prev, b) => prev + (Number(b.PART) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"}</Text>
          </View>
        </View>
      </View>

      {!!sortis?.length && <View style={styles.titlesView}>
        <Text>
          Historique Encaissements : 
        </Text>
      </View>}
      {!!sortis?.length && <View wrap={false}>
        <View style={{...styles.table, ...styles.lastElement}}>
          <View style={styles.tableRow} wrap={false}>
            <View style={Object.assign({}, styles.rowCol, {width: "50%"})}>
              <Text style={Object.assign({}, styles.cellText, styles.headerText)}>Valeurs Remplacées</Text>
            </View>
            <View style={Object.assign({}, styles.rowCol, {width: "50%"})}>
              <Text style={Object.assign({}, styles.cellText, styles.headerText)}>Valeurs de Remplacement</Text>
            </View>
          </View>
          <View style={styles.tableRow} wrap={false}>
            {sortisColumns.map((e, key) => 
              <View style={Object.assign({}, styles.headerCol, {width: e.width + "%"})} key={key}>
                <Text style={Object.assign({}, styles.cellText, styles.headerText)}>{ e.value }</Text>
              </View>
            )}
          </View>
          {sortis.map((sorti, rowKey) => {
            return <View style={styles.tableRow} key={rowKey} wrap={false}>
              {[sorti.ref_encaissement || "-", Number(sorti.montant) || 0, Number(sorti.QUOTE_PART) || 0, getEncStatut(sorti.statut, true)/*, sorti.statut === "RECEPTION" ? "Non Récep." : sorti.statut === "PTF" ? "Réceptionné" : sorti.statut === "EI" ? "Versé" : sorti.statut === "ENCAISSE" ? "Encaissé" : sorti.statut === "IMPAYE" ? "Impayé" : (sorti.statut || "")*/, `- CHE | ${sorti.encaissement.REF_REGLEMENT || "-"} | MNT GLB ${Number(sorti.encaissement.MONTANT || 0)} | MNT QP ${Number(sorti.CE_PART || 0)}`].map((e, key) => 
                <View style={Object.assign({}, styles.rowCol, {width: sortisColumns[key].width + "%"})} key={key}>
                  <Text style={Object.assign({}, styles.cellText, {fontSize: "8px"})}>{ (e = e || 0, sortisColumns[key].formatNumber ? Number(e).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : sortisColumns[key].isDecimal ? Number((+e).toFixed(2)) : e) }</Text>
                </View>
              )}
            </View>
          })}
          <View style={Object.assign({}, styles.rowCol, styles.footerCol, {width: sortisColumns[1].width + "%", marginLeft: sortisColumns[0].width + "%"})}>
            <Text style={Object.assign({}, styles.cellText, {fontSize: "8px"})}>{sortis.reduce((prev, b) => prev + (Number(b.montant) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') || "-"}</Text>
          </View>
        </View>
      </View>}
      
      <View style={styles.pageCountContainer} fixed>
        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => totalPages > 1 && `${pageNumber} / ${totalPages}`} fixed />
        <View style={{display: "flex", justifyContent: "space-between", flexDirection: "row"}}>
          <Text>{data.REMISE_VALIDEE === -1 && data.REMISE > 0 ? "* Demande de remise pas encore approuvée par l'administration et n'est pas comprise dans le prix net." : data.REMISE_VALIDEE === 0 && data.REMISE > 0 ? "* Demande de remise refusée par l'administration." : " "}</Text>
          <Text style={{textAlign: "right"}}>Imprimé le: {moment().format('DD/MM/YYYY')}</Text>
        </View>
      </View>
    </MyPage>
  </MyDocument>
  )
};

export default VenteDocument;
